import JSONLD from "src/utils/jsonld";

import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { getResourceUuid } from "../../utils/getResourceUuid";
import { IClassroom } from "../types/IClassroom";

interface ClassroomUpdateMutationData extends Partial<
    Pick<
        IClassroom,
        | "title"
        | "description"
        | "startDate"
        | "endDate"
        | "externalReferences"
        | "dailyStartHour"
        | "dailyEndHour"
        | "isBadgesEnabled"
        | "isReflexiveTutorEnabled"
    >
> {
    frameworks?: RelationalValue<IClassroom["frameworks"][number]>[];
    location?: RelationalValue<Required<IClassroom>["location"]>;
    factory?: RelationalValue<IClassroom["factory"]>;
    language?: RelationalValue<IClassroom["language"]>;
    image?: RelationalValue<NonNullable<IClassroom["image"]>>;
}

export type IClassroomUpdateMutationParameters = {
    classroom: RelationalValue<IClassroom>;
    data: ClassroomUpdateMutationData;
};

export type IClassroomUpdateMutationResult = IClassroom;

export const classroomUpdateMutation: IApiMutationFunction<IClassroomUpdateMutationParameters> = ({
    classroom,
    data,
}) => {
    return {
        method: "PUT",
        url: `/classrooms/${getResourceUuid(classroom)}`,
        data: JSONLD.normalize(data),
    };
};

export const useClassroomUpdateMutation = createApiMutationHook<
    IClassroomUpdateMutationParameters,
    IClassroomUpdateMutationResult
>(classroomUpdateMutation);
